import { routes } from "router";

export const getRouteMap = () => ({
  deactivated: {
    details: routes.proEditExperienceDeactivateBackRoutePathDetails,
    scheduling: routes.proEditExperienceDeactivateBackRoutePathScheduling,
    media: routes.proEditExperienceDeactivateBackRoutePathMedia,
    resources: routes.proEditExperienceDeactivateBackRoutePathResources,
    location: routes.proEditExperienceDeactivateBackRoutePathLocation,
    preview: routes.proEditExperienceDeactivateBackRoutePathPreview,
    default: routes.proExperiencePathDeactivatedPath,
  },
  published: {
    details: routes.proEditExperiencePublishBackRoutePathDetails,
    scheduling: routes.proEditExperiencePublishBackRoutePathScheduling,
    media: routes.proEditExperiencePublishBackRoutePathMedia,
    resources: routes.proEditExperiencePublishBackRoutePathResources,
    location: routes.proEditExperiencePublishBackRoutePathResLocation,
    preview: routes.proEditExperiencePublishBackRoutePathResPreview,
    default: routes.proExperiencePathPublishedPath,
  },
  draft: {
    details: routes.proEditExperienceDraftBackRoutePathDetails,
    scheduling: routes.proEditExperienceDraftBackRoutePathScheduling,
    media: routes.proEditExperienceDraftBackRoutePathMedia,
    resources: routes.proEditExperienceDraftBackRoutePathResources,
    location: routes.proEditExperienceDraftBackRoutePathLocation,
    preview: routes.proEditExperienceDraftBackRoutePathPreview,
    default: routes.proExperiencePathDraft,
  },
  create: {
    details: routes.proNewListingDetailsPath,
    scheduling: routes.proNewListingSchedulingPath,
    media: routes.proNewListingMediaPath,
    resources: routes.proNewListingResourcesPath,
    location: routes.proNewListingLocationPath,
    preview: routes.proNewListingPreviewPath,
    default: routes.proNewListingRootPath,
  },
});
